import React from 'react';
import { BsBehance, BsGithub,BsInstagram } from 'react-icons/bs';
import { GrLinkedinOption} from 'react-icons/gr';
import { FaFacebookF } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './common.scss';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href = "https://www.behance.net/namangaur2 " target="_blank" ><BsBehance /></a>
    </div>
    <div>
      <a href = "https://github.com/namangaur2 " target="_blank" ><BsGithub/></a>
    </div>
    <div>
      <a href = "https://www.linkedin.com/in/naman-gaur-054b581aa/" target="_blank" ><GrLinkedinOption /></a>
    </div>
    
    <div>
      <a href = "https://www.instagram.com/naman_gaur2002/" target="_blank" ><BsInstagram /></a>
    </div>
  </div>
);

export default SocialMedia;